module.exports = __webpack_public_path__ + "img/shoeprint_2.86a3bbe5.jpg";